export default class BaseStore {
  // things to go in here TBD
}
